<template>
    <DCard
        padding
    >
        <Form
            :s3-settings="s3Settings"
            :errors="errors"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/S3Settings/Form'
import { route } from '~@/Composables/route'

defineProps({
    s3Settings: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const submitForm = function (form) {
    form.post(route('settings.s3-settings.store'))
}
</script>

<style scoped lang="scss">

</style>
